module.exports = __webpack_public_path__ + "img/61769c140faa8de09ec5b1e10b054667.62be6b9d.jpg";